import React, { createContext, useContext, useMemo } from 'react';

export type ChatSource = 'embedded' | 'full_screen' | 'sidebar';

interface ChatSourceContextValue {
  source: ChatSource;
}

const ChatSourceContext = createContext<ChatSourceContextValue | null>(null);

export const ChatSourceProvider: React.FC<{ source: ChatSource; children: React.ReactNode }> = ({
  source,
  children,
}) => {
  const value = useMemo(() => ({ source }), [source]);
  return <ChatSourceContext.Provider value={value}>{children}</ChatSourceContext.Provider>;
};

export const useChatSource = (): ChatSource | undefined => {
  const context = useContext(ChatSourceContext);
  return context?.source;
};
